import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import type { ChangeEvent } from 'react';

import { EMPTY_STRING } from '@e-socna/empty';
import type { Id } from '@e-socna/data-layer';

import type { QuotationActorOption } from '../hooks/useQuotationCollaboration.hook';

interface Props {
  readonly disabled: boolean;
  readonly error?: string;
  readonly id: string;
  readonly label: string;
  readonly onChange?: (event: Readonly<ChangeEvent<HTMLInputElement>>) => void;
  readonly options: readonly QuotationActorOption[];
  readonly value: Id | undefined;
}

export const QuotationActorSelect = ({
  disabled,
  error,
  id,
  label,
  onChange: handleChange,
  options,
  value,
}: Readonly<Props>) => (
  <TextField
    disabled={disabled}
    error={!!error}
    fullWidth
    helperText={error}
    id={id}
    label={label}
    onChange={handleChange}
    select
    value={value ?? EMPTY_STRING}
  >
    {options.map((option) => (
      <MenuItem key={option.thirdPartyId} value={option.thirdPartyId}>
        {option.name}
      </MenuItem>
    ))}
  </TextField>
);
